import { useSyncExternalStore } from 'react';
import {
  InputModalityStore,
  type InputModalitySnapshot,
} from '../../systems/input/InputModalityStore';

const SERVER_SNAPSHOT: InputModalitySnapshot = Object.freeze({
  modality: 'keyboard-pointer',
  gamepadIndex: null,
  gamepadId: null,
  controller: null,
});

/** React projection of InputSystem's sticky last-used-device state. */
export function useInputModality(): InputModalitySnapshot {
  return useSyncExternalStore(
    InputModalityStore.subscribe,
    InputModalityStore.getSnapshot,
    () => SERVER_SNAPSHOT,
  );
}
